<template>
  <div class="scene-setting">
    <my-header :title="`${initData.name}设置`" back-path="/user/linkage">
      <span class="save" @click="save">保存</span>
    </my-header>
    <div class="container">
      <div class="content" v-if="initData.type">
        <div class="part">
          <span class="title">当满足以下条件时</span>
          <div class="cot">
            <div class="left_cot">
              <span class="icon"><img :src="require(`@/assets/images/linkage/${renderList[initData.type]['icon']}`)" alt=""></span>
              <span class="tit">室内{{initData.name === '冬天温度' ? renderList[initData.type]['ttitle'][1] : renderList[initData.type]['ttitle'][0]}}</span>
            </div>
            <div class="right_cot">
              <div class="condition_pir"  v-if="initData.type == 'PIR'">
                 <div class="button">有人</div>
                 <label class="delayTime" for="delayTime">延迟关灯：
                      <input id="delayTime" type="text" v-model="initData.delayTime" @input="$event.target.value=$event.target.value.replace(/\D/g,'')">
                      秒
                 </label>
                 <div class="limit">
                  <span class="txt">不执行时间段:</span>
                    <el-time-picker
                        v-model="initData.timeLimit.start"
                        placeholder="开始时间">
                      </el-time-picker>
                      <el-time-picker
                        v-model="initData.timeLimit.end"
                        placeholder="结束时间">
                      </el-time-picker>
                 </div>
              </div>
              <div class="input-number" v-else>
                <el-input-number v-model="initData.condition.max" :min="initData.viewRange.min" :max="initData.viewRange.max" label="%" size="mini"></el-input-number>
                <i class="unit">{{renderList[initData.type]['unit']}}</i>
              </div>
            </div>
          </div>
        </div>
        <div class="part">
          <span class="title">就执行以下动作</span>
          <div class="action_cot" v-for="(item, index) in initData.action" :key="index">
            <div class="aircon_tempalte tempalte" v-if="item.type === 'aircon' && item.isShow">
             <div class="cot">
                <div class="left_cot">
                  <span class="icon"><img src="@/assets/images/linkage/airconditioning.png" alt=""></span>
                  <span class="tit">空调</span>
                </div>
                <div class="right_cot">
                  <el-switch v-model="item.state" active-color="#3AD474" :active-value="1" :inactive-value="0"></el-switch>
                </div>
              </div>
              <div class="cot no-top">
                <div class="left_cot">
                  <span class="icon"></span>
                  <span class="tit">温度设置</span>
                </div>
                <div class="right_cot">
                  <div class="input-number">
                     <el-input-number v-model="item.tt" :min="16" :max="30" label="%" size="mini"></el-input-number>
                  </div>
                </div>
              </div>
              <div class="cot no-top">
                <div class="left_cot">
                  <span class="icon"></span>
                  <span class="tit">模式设置</span>
                </div>
                <div class="right_cot">
                  <ul class="button_group">
                    <li :class="{active: item.mode === 0}" @click="changeMode(item, 0)">制冷</li>
                    <li :class="{active: item.mode === 1}" @click="changeMode(item, 1)">制热</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="curtain_tempalte tempalte" v-if="item.type === 'curtain' && item.isShow">
             <div class="cot">
                <div class="left_cot">
                  <span class="icon"><img src="@/assets/images/linkage/curtain.png" alt=""></span>
                  <span class="tit">窗帘</span>
                </div>
                <div class="right_cot">
                  <el-switch v-model="item.state" active-color="#3AD474" :active-value="1" :inactive-value="2"></el-switch>
                </div>
              </div>
            </div>
            <div class="light_tempalte tempalte" v-if="item.type === 'light' && item.isShow">
             <div class="cot">
                <div class="left_cot">
                  <span class="icon"><img src="@/assets/images/linkage/light.png" alt=""></span>
                  <span class="tit">灯具</span>
                </div>
                <div class="right_cot">
                  <el-switch v-model="item.state" active-color="#3AD474" :active-value="1" :inactive-value="0"></el-switch>
                </div>
              </div>
            </div>
            <div class="airpure_tempalte tempalte" v-if="item.type === 'airpure' && item.isShow">
             <div class="cot">
                <div class="left_cot">
                  <span class="icon"><img src="@/assets/images/linkage/freshair.png" alt=""></span>
                  <span class="tit">新风</span>
                </div>
                <div class="right_cot">
                  <el-switch v-model="item.state" active-color="#3AD474" :active-value="1" :inactive-value="0"></el-switch>
                </div>
              </div>
              <div class="cot no-top">
                <div class="left_cot">
                  <span class="icon"></span>
                  <span class="tit">模式设置</span>
                </div>
                <div class="right_cot">
                  <ul class="button_group">
                    <li :class="{active: item.air === 1}" @click="changeMode(item, 1)">低风</li>
                    <li :class="{active: item.air === 2}" @click="changeMode(item, 2)">中风</li>
                    <li :class="{active: item.air === 3}" @click="changeMode(item, 3)">高风</li>
                  </ul>
                </div>
              </div>
            </div>
             <div class="switch_tempalte tempalte" v-if="item.type === 'switch' && item.isShow">
             <div class="cot">
                <div class="left_cot">
                  <span class="icon"><img src="@/assets/images/linkage/humidifier1.png" alt=""></span>
                  <span class="tit">加湿器</span>
                </div>
                <div class="right_cot">
                  <el-switch v-model="item.state" active-color="#3AD474" :active-value="1" :inactive-value="0"></el-switch>
                </div>
              </div>
            </div>
          </div>
          <div class="cot">
            <div class="left_cot">
              <span class="icon"><img src='@/assets/images/linkage/scenes.png' alt=""></span>
              <span class="tit">场景</span>
            </div>
            <div class="right_cot">
              <div class="button" :class="{actives: initData.scene === item.id}" v-for="(item, index) in itemList" :key="index" @click="changeScene(item)">{{item.name}}模式</div>
            </div>
          </div>
        </div>
        <div class="part">
          <span class="title">当满足以下条件时</span>
          <div class="cot">
            <div class="left_cot">
              <span class="icon"><img :src="require(`@/assets/images/linkage/${renderList[initData.type]['icon']}`)" alt=""></span>
              <span class="tit">室内{{initData.name === '冬天温度' ? renderList[initData.type]['btitle'][1] : renderList[initData.type]['btitle'][0]}}, 则取消联动</span>
            </div>
            <div class="right_cot">
              <div class="input-number" v-if="initData.type != 'PIR'">
                <el-input-number v-model="initData.condition.min" :min="initData.viewRange.min" :max="initData.viewRange.max" label="%" size="mini"></el-input-number>
                <i class="unit">{{renderList[initData.type]['unit']}}</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/HeaderTitle'
import { mapState } from 'vuex'
import basic from '@/model/zone'
import scene from '@/model/scene'
import { Message } from 'element-ui'
import cache from '../../assets/lib/cache'
import linkage from '@/model/linkage'

export default {
  name: 'LinkAgeEdit',
  components: {
    MyHeader
  },
  data () {
    return {
      itemList: [],
      initData: {},
      renderList: {
        DHTt: {
          icon: 'temperature.png',
          ttitle: ['温度高于', '温度低于'],
          btitle: ['温度低于该温度', '温度高于该温度'],
          unit: '℃',
          deviceType: ['aircon']
        },
        ALS: {
          icon: 'temperature.png',
          ttitle: ['光照度高于'],
          btitle: ['光照度低于该光照度时'],
          unit: 'lux',
          deviceType: ['curtain']
        },
        PM25: {
          icon: 'pm2.5_b.png',
          ttitle: ['PM2.5高于'],
          btitle: ['PM2.5低于该PM2.5时'],
          unit: 'μg/m³',
          deviceType: ['airpure']
        },
        PM10: {
          icon: 'pm10_b.png',
          ttitle: ['PM10高于'],
          btitle: ['PM10低于该PM10时'],
          unit: 'μg/m³',
          deviceType: ['airpure']
        },
        CO2: {
          icon: 'co2_b.png',
          ttitle: ['二氧化碳高于'],
          btitle: ['二氧化碳低于该二氧化碳时'],
          unit: 'μg/m³',
          deviceType: ['airpure']
        },
        CH2O: {
          icon: 'formaldehyde_b.png',
          ttitle: ['甲醛高于'],
          btitle: ['甲醛低于该甲醛时'],
          unit: 'μg/m³',
          deviceType: ['airpure']
        },
        TVOC: {
          icon: 'tvoc_b.png',
          ttitle: ['TVOC高于'],
          btitle: ['TVOC低于该TVOC时'],
          unit: 'μg/m³',
          deviceType: ['airpure']
        },
        DHTh: {
          icon: 'humidifier1.png',
          ttitle: ['湿度低于'],
          btitle: ['湿度高于该湿度时'],
          unit: '%',
          deviceType: ['switch']
        },
        PIR: {
          icon: 'humantouch1.png',
          ttitle: ['检测到'],
          btitle: ['无人时'],
          unit: '',
          deviceType: ['light']
        }
      }
    }
  },
  computed: {
    ...mapState(['zone', 'linkage', 'coreIds', 'extDevices'])
  },
  async created () {
    if (!this.zone) {
      await basic.getBasicInfo()
      this.initScenes()
    } else {
      this.initScenes()
    }
  },
  methods: {
    async initScenes () {
      const result = await scene.get(this.zone.id)
      this.itemList = result.data
    },
    changeMode (item, val) {
      if (item.type === 'aircon') {
        item.mode = val
      } else {
        item.air = val
      }
    },
    changeScene (item) {
      if (this.initData.scene === item.id) {
        this.initData.scene = ''
      } else {
        this.initData.scene = item.id
      }
    },
    async save () {
      let originData = JSON.parse(JSON.stringify(this.linkage))
      // 修改描述
      let obj = this.renderList[this.initData.type]

      this.initData.description = `当室内${this.initData.name === '冬天温度' ? obj['ttitle'][1] : obj['ttitle'][0]}${this.initData.condition.max ? this.initData.condition.max : '有人时'}${obj['unit']}， ${this.describ()}`
      // 添加命令
      this.cmd()
      // 更新数据
      let index = originData.rule.findIndex(item => item.type === this.initData['type'] && item.name === this.initData['name'])
      originData['rule'][index] = this.initData
      this.initData.isSave = true
      await linkage.updataLinkAge({ zoneId: this.zone.id, deviceId: this.coreIds, rule: originData.rule, id: this.linkage.id })
      this.$store.commit('SET_LINKAGE', { id: this.linkage.id, rule: originData.rule })
      // 返回上一页
      this.$router.push('/user/linkage')
    },
    describ () {
      let type = {
        aircon: '空调',
        curtain: '窗帘',
        airpure: '新风',
        switch: '加湿器',
        light: '灯具'
      }
      let mode = ['制冷模式', '制热模式']
      let air = ['低风模式', '中风模式', '高风模式']
      let action = []
      this.initData.action.forEach(item => {
        action.push(`执行${item.state === 1 ? '打开' : '关闭'}${type[item.type]}${item.mode !== undefined ? '，' + mode[item.mode] : ''}${item.air !== undefined ? '，' + air[item.air - 1] : ''}`)
      })
      return action.join(',')
    },
    cmd () {
      console.log(this.extDevices)
      let cmd = {
        switch: {
          1: { cmd: 8, nd: 255, msg: 1, ack: 1, tag: 67, tp: [8], pl: '1000' },
          0: { cmd: 8, nd: 255, msg: 1, ack: 1, tag: 67, tp: [8], pl: '0000' }
        },
        curtain: {
          1: { cmd: 8, nd: 255, tp: [2], ack: 1, msg: 1, tag: 29, pl: 'p1' },
          2: { cmd: 8, nd: 255, tp: [2], ack: 1, msg: 1, tag: 30, pl: 'p2' }
        },
        light: {
          1: { cmd: 1, nd: 255, tp: [1], state: 1 },
          0: { cmd: 1, nd: 255, tp: [1], state: 0 }
        },
        airpure: {
          1: { cmd: 8, nd: 255, tp: [5], ack: 1, msg: 1, tag: 8, dt: [2, 2] },
          2: { cmd: 8, nd: 255, tp: [5], ack: 1, msg: 1, tag: 8, dt: [2, 3] },
          3: { cmd: 8, nd: 255, tp: [5], ack: 1, msg: 1, tag: 8, dt: [2, 4] },
          0: { cmd: 8, nd: 255, tp: [5], ack: 1, msg: 1, tag: 8, dt: [1, 0] }
        }
      }
      this.initData.action.forEach(item => {
        if (item.type === 'aircon') {
          // 空调单独处理， 处理空调码
          let aircons = this.extDevices && this.extDevices.filter(item => item.devicetypeId === 4 || item.devicetypeId === 17).map(item => {
            let cmd = JSON.parse(item.cmd.cmd)
            return cmd.code
          })
          item['opencmd'] = []
          item['closecmd'] = []
          aircons.forEach(itm => {
            item['opencmd'].push({ cmd: 8, nd: 255, tag: 21, tp: [3], ack: 1, msg: 1, pl: { 'state': item.state, 'mode': item.mode, 'air': 2, 'tt': item.tt }, code: itm })
            item['closecmd'].push({ cmd: 8, nd: 255, tag: 21, tp: [3], ack: 1, msg: 1, pl: { 'state': item.state ? 0 : 1 }, code: itm })
          })
        } else if (item.type === 'curtain') {
          item['opencmd'] = cmd[item.type][item.state]
          item['closecmd'] = item.state === 1 ? cmd[item.type][2] : cmd[item.type][1]
        } else if (item.type === 'airpure') {
          item['opencmd'] = item.state && item.air ? cmd[item.type][item.air] : cmd[item.type][item.state]
          item['closecmd'] = item.state ? cmd[item.type][0] : cmd[item.type][1]
        } else {
          item['opencmd'] = cmd[item.type][item.state]
          item['closecmd'] = item.state ? cmd[item.type][0] : cmd[item.type][1]
        }
      })
    }
  },
  mounted () {
    // 保存刷新
    let value = null
    if (this.$route.params.type) {
      value = this.$route.params
      cache.setCache('currentLinkAge', this.$route.params)
    } else {
      value = cache.getCache('currentLinkAge')
    }
    this.initData = JSON.parse(JSON.stringify(value))
  }
}
</script>

<style scoped lang="less">
*{ -webkit-tap-highlight-color: rgba(0,0,0,0); /* For some Androids */ }
*{-webkit-tap-highlight-color: transparent;}
i {
font-style: normal;
}
.scene-setting {
  height: 100%;
  display: flex;
  flex-direction: column;
  .save {
    font-size: 17px;
    color: rgba(58, 212, 116, 1);
    font-weight: 400;
    cursor: pointer;
  }
  .container {
    flex: 1;
    position: relative;
    padding: 65px 20px 0px 20px;
    overflow-y: auto;
    .part {
       margin-bottom: 40px;
      .title {
        font-size:18px;
        font-family:PingFang SC;
        font-weight:600;
        color:rgba(34,34,34,1);
      }
      .cot {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height:62px;
        background:rgba(255,255,255,1);
        border-radius:8px;
        padding: 0 20px;
        margin-top: 16px;
        .left_cot {
          display: flex;
          align-items: center;
          .icon {
            width: 40px;
            height: 40px;
            border-radius:50%;
            margin-right: 15px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .tit {
            font-size: 18px;
            color:rgba(34,34,34,1);
          }
        }
        .right_cot {
          display: flex;
          flex-flow: row wrap;
          justify-content: flex-start;
          align-items: center;
          max-width: 700px;
          margin: 10px 0 0;
          .condition_pir {
            display: flex;
            justify-content: space-between;
            color: #636363;
            .delayTime {
              color: #636363;
              margin-top: 3px;
              font-size: 14px;
              margin-right: 10px;
              input {
                outline: none;
                height: 24px;
                line-height: 24px;
                text-indent: 10px;
                width: 50px;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
              }
            }
            .limit {
              display: flex;
              align-items: center;
              margin-top: -13px;
              .txt {
                font-size: 14px;
                color: #636363;
              }
              /deep/ .el-date-editor {
                 width: 120px;
                 margin-right: 10px;
                 display: flex;
                .el-input__inner {
                  height: 30px;
                  line-height: 30px;
                }
                .el-input__icon {
                    line-height: 30px;
                  }
              }
            }
          }
          .button {
            height:34px;
            background:rgba(255,255,255,1);
            color:rgba(99,99,99,1);
            border:1px solid rgba(220,223,230,1);
            border-radius:4px;
            padding: 0 12px;
            line-height: 34px;
            font-size:14px;
            cursor: pointer;
            margin-right: 12px;
            margin-bottom: 10px;
            cursor: pointer;
          }
          .button_group {
            display: flex;
            margin-bottom: 10px;
            li {
              height: 34px;
              padding: 0 14px;
              font-size: 14px;
              color:rgba(99,99,99,1);
              border:1px solid rgba(220,223,230,1);
              border-radius:4px;
              line-height: 34px;
              cursor: pointer;
              border-right: 0;
            }
            li:first-child {
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
            }
            li:last-child {
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              border-right:1px solid rgba(220,223,230,1);
            }
            .active {
              border: 1px solid rgba(58, 212, 116, 1) !important;
              color:rgba(58, 212, 116, 1);
            }
          }
          .actives {
            background:rgba(58,212,116,1);
            border:1px solid rgba(58,212,116,1);
            border-radius:4px;
            color:rgba(255,255,255,1);;
          }
        }
        .input-number {
          position: relative;
          height: 34px;
          margin-bottom: 10px;
          /deep/.el-input__inner {
                height: 34px;
                line-height: 34px;
          }
          /deep/.el-input-number--mini .el-input-number__decrease{
                width: 34px;
                height: 32px;
                display: flex;
                justify-content: center;
                align-items: center;
          }
          /deep/.el-input-number--mini .el-input-number__increase {
                width: 34px;
                height: 32px;
                justify-content: center;
                align-items: center;
          }
          /deep/ .el-input-number--mini {
            line-height: 34px;
            input {
              font-size: 16px;
              color: rgba(99, 99, 99, 1);
            }
          }
          .unit {
            // position: absolute;
            // top: 24%;
            // right: 30%;
            margin-left: 5px;
            font-size: 16px;
            z-index: 10;
            font-weight: 400;
            color: rgba(99, 99, 99, 1);
          }
        }
      }
      .no-top {
        margin-top: 0;
      }
      .action_cot {
        border-radius: 8px;
        background: #fff;
        .cot {
          border-radius: 0;
          background: none;
        }
      }
    }
  }
}
</style>
